import { Box, css, styled } from '@mui/material';

const PrivacyWrapper = styled(Box)(
  css`
    counter-reset: section;
  `,
);

export default PrivacyWrapper;
